import { Vector3 } from 'three';
import type { BufferGeometry } from 'three';

/**
 * 从 BufferGeometry 的 position 属性读取顶点序列，每 3 个数字封装为一个 Vector3。
 *
 * 设计说明：
 * 1. 草图线状实体（直线/圆弧/椭圆弧/抛物线/圆/样条）的 updateGeometry 都会把
 *    世界坐标采样点写入 geometry.attributes.position，因此该数据与当前渲染几何
 *    完全一致，是"当前实体真实轮廓"的权威来源，无需调用方自行插值或重新采样；
 * 2. 使用 getX/getY/getZ 读取而非直接切 array，可同时兼容普通 BufferAttribute
 *    与 InterleavedBufferAttribute，避免底层存储布局差异；
 * 3. position 缺失或顶点数不足时返回空数组，由调用方降级处理，不抛异常。
 *
 * @param geometry 目标几何体；允许为空（对象尚未初始化几何时）。
 * @returns 世界坐标顶点数组；无 position 属性时返回空数组。
 */
export function readGeometryPositionPoints(
    geometry: BufferGeometry | null | undefined,
): Vector3[] {
    if (!geometry) {
        return [];
    }

    const position = geometry.getAttribute('position');
    if (!position || position.count < 1) {
        return [];
    }

    const points: Vector3[] = [];
    for (let index = 0; index < position.count; index += 1) {
        points.push(new Vector3(
            position.getX(index),
            position.getY(index),
            position.getZ(index),
        ));
    }
    return points;
}
